import React, { Component, createRef } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { hasSubmittedToday, markSubmittedToday, DUPLICATE_LEAD_MESSAGE } from "../../../Common/leadDedupe";

class EnquiryFormModal extends Component {
    constructor(props) {
        super(props);

        this.recaptchaRef = createRef();

        this.state = {
            name: "",
            email: "",
            mobile: "",
            location: "",
            otherLocation: "",
            model: "",

            loading: false,
            success: false,

            successMessage: "",
            errorMessage: "",
            captchaToken: null,
        };
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleCaptchaChange = (token) => {
        this.setState({ captchaToken: token });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const {
            name,
            email,
            mobile,
            location,
            model,
            otherLocation,
        } = this.state;

        // VALIDATION
        if (
            !name ||
            !email ||
            !mobile ||
            !location ||
            !model ||
            (location === "Other" && !otherLocation)
        ) {
            this.setState({
                errorMessage: "Please fill all fields",
            });

            return;
        }

        const emailRegex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            this.setState({
                errorMessage: "Invalid email address",
            });

            return;
        }

        const mobileRegex = /^[0-9]{10}$/;

        if (!mobileRegex.test(mobile)) {
            this.setState({
                errorMessage: "Invalid mobile number",
            });

            return;
        }

        if (hasSubmittedToday(mobile)) {
            this.setState({
                errorMessage: DUPLICATE_LEAD_MESSAGE,
            });

            return;
        }

        if (!this.state.captchaToken) {
            this.setState({
                errorMessage: "Please verify you're not a robot",
            });

            return;
        }

        try {
            this.setState({
                loading: true,
                errorMessage: "",
                successMessage: "",
            });

            await axios.post(
                "https://api.centralkia.co.in/api/enquiry/add-enquiry",
                {
                    name,
                    email,
                    mobile,

                    location:
                        location === "Other"
                            ? otherLocation
                            : location,

                    model,
                    captchaToken: this.state.captchaToken,
                }
            );
            // Google Ads Conversion Tracking
            console.log("Google Ads Conversion Fired");

            if (typeof window.gtag === "function") {
                window.gtag("event", "conversion", {
                    send_to: "AW-705253839/dpJXCM6N-7kcEM-jpdAC",
                    value: 1.0,
                    currency: "INR",
                });
            }
            markSubmittedToday(mobile);
            this.recaptchaRef.current?.reset();

            this.setState({
                loading: false,
                success: true,

                successMessage:
                    "Enquiry submitted successfully",

                name: "",
                email: "",
                mobile: "",
                location: "",
                otherLocation: "",
                model: "",
                captchaToken: null,
            });

            // AUTO CLOSE
            setTimeout(() => {
                this.props.onClose();
            }, 2500);

        } catch (error) {

            this.recaptchaRef.current?.reset();

            this.setState({
                loading: false,
                captchaToken: null,

                errorMessage:
                    error?.response?.data?.message ||
                    "Something went wrong",
            });

        }
    };

    render() {

        const { open, onClose } = this.props;

        if (!open) return null;

        const isMobile =
            window.innerWidth <= 768;

        const inputStyle = {
            width: "100%",
            height: isMobile ? "52px" : "54px",
            padding: "0 16px",
            borderRadius: "14px",
            border: "1px solid #ddd",
            background: "#fafafa",
            color: "#111",
            fontSize: isMobile ? "14px" : "15px",
            outline: "none",
            boxSizing: "border-box",
        };

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.65)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 99999,
                    padding: isMobile ? "12px" : "20px",
                    boxSizing: "border-box",
                }}
            >
                <div
                    style={{
                        width: isMobile ? "92%" : "500px",
                        background: "#fff",
                        borderRadius: isMobile
                            ? "20px"
                            : "16px",
                        padding: isMobile
                            ? "20px 16px"
                            : "32px",
                        position: "relative",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        boxSizing: "border-box",
                    }}
                >

                    {/* CLOSE BUTTON */}
                    <button
                        onClick={onClose}
                        style={{
                            position: "absolute",
                            top: isMobile ? "10px" : "12px",
                            right: isMobile ? "12px" : "14px",
                            border: "none",
                            background: "transparent",
                            fontSize: isMobile ? "24px" : "28px",
                            cursor: "pointer",
                            color: "#111",
                            zIndex: 10,
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </button>

                    {/* THANK YOU SCREEN */}
                    {this.state.success ? (

                        <div
                            style={{
                                textAlign: "center",
                                padding: isMobile
                                    ? "30px 10px"
                                    : "40px 20px",
                            }}
                        >

                            {/* SUCCESS ICON */}
                            <div
                                style={{
                                    width: isMobile ? "70px" : "85px",
                                    height: isMobile ? "70px" : "85px",
                                    background: "#d91c2b",
                                    borderRadius: "50%",
                                    margin: "0 auto 20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "#fff",
                                    fontSize: isMobile ? "34px" : "42px",
                                    fontWeight: "bold",
                                }}
                            >
                                🙏
                            </div>

                            <h1
                                style={{
                                    margin: 0,
                                    color: "#111",
                                    fontSize: isMobile
                                        ? "28px"
                                        : "38px",
                                    fontWeight: "800",
                                }}
                            >
                                Thank You!
                            </h1>

                            <p
                                style={{
                                    marginTop: "14px",
                                    color: "#666",
                                    fontSize: isMobile
                                        ? "14px"
                                        : "16px",
                                    lineHeight: "1.7",
                                }}
                            >
                                Your enquiry has been
                                submitted successfully.
                                <br />
                                Our team will contact you soon.
                            </p>

                        </div>

                    ) : (

                        <>
                            {/* HEADING */}
                            <h1
                                style={{
                                    margin: 0,
                                    color: "#111",
                                    fontSize: isMobile
                                        ? "28px"
                                        : "38px",
                                    fontWeight: "800",
                                    textAlign: "center",
                                    lineHeight: "1.1",
                                    marginTop: "5px",
                                }}
                            >
                                ENQUIRE NOW
                            </h1>

                            <p
                                style={{
                                    marginTop: "10px",
                                    marginBottom: "24px",
                                    color: "#666",
                                    textAlign: "center",
                                    fontSize: isMobile
                                        ? "12px"
                                        : "14px",
                                    lineHeight: "1.5",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                OFFERS | TEST DRIVE | BOOK NOW
                            </p>

                            {/* ERROR */}
                            {this.state.errorMessage && (
                                <div
                                    style={{
                                        background: "#f8d7da",
                                        color: "#721c24",
                                        padding: "12px",
                                        borderRadius: "10px",
                                        marginBottom: "15px",
                                        fontSize: "14px",
                                    }}
                                >
                                    {this.state.errorMessage}
                                </div>
                            )}

                            <form onSubmit={this.handleSubmit}>

                                {/* NAME */}
                                <div style={{ marginBottom: "14px" }}>
                                    <input
                                        type="text"
                                        name="name"
                                        required
                                        placeholder="First Name *"
                                        value={this.state.name}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    />
                                </div>

                                {/* EMAIL */}
                                <div style={{ marginBottom: "14px" }}>
                                    <input
                                        type="email"
                                        name="email"
                                        required
                                        placeholder="Email"
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    />
                                </div>

                                {/* PHONE */}
                                <div style={{ marginBottom: "14px" }}>
                                    <input
                                        type="tel"
                                        name="mobile"
                                        required
                                        maxLength="10"
                                        placeholder="Phone *"
                                        value={this.state.mobile}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    />
                                </div>

                                {/* LOCATION */}
                                <div style={{ marginBottom: "14px" }}>
                                    <select
                                        required
                                        name="location"
                                        value={this.state.location}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    >
                                        <option value="">
                                            Select Location
                                        </option>

                                        <option value="Bhubaneswar">
                                            Bhubaneswar
                                        </option>

                                        <option value="Angul">
                                            Angul
                                        </option>

                                        <option value="Raghunathpur">
                                            Raghunathpur
                                        </option>

                                        <option value="Berhampur">
                                            Berhampur
                                        </option>

                                        <option value="Sambalpur">
                                            Sambalpur
                                        </option>

                                        <option value="Cuttack">
                                            Cuttack
                                        </option>

                                        <option value="Other">
                                            Other
                                        </option>
                                    </select>
                                </div>

                                {/* OTHER LOCATION */}
                                {this.state.location === "Other" && (
                                    <div style={{ marginBottom: "14px" }}>
                                        <input
                                            type="text"
                                            name="otherLocation"
                                            required
                                            placeholder="Enter Your Location"
                                            value={this.state.otherLocation}
                                            onChange={this.handleChange}
                                            style={inputStyle}
                                        />
                                    </div>
                                )}

                                {/* MODEL */}
                                <div style={{ marginBottom: "26px" }}>
                                    <select
                                        required
                                        name="model"
                                        value={this.state.model}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    >
                                        <option value="">
                                            Select Model
                                        </option>

                                        <option value="seltos">
                                            Seltos
                                        </option>

                                        <option value="sonet">
                                            Sonet
                                        </option>

                                        <option value="carens">
                                            Carens
                                        </option>


                                        <option value="carnival">
                                            Carnival
                                        </option>



                                        <option value="syros">
                                            Syros
                                        </option>

                                        <option value="syros ev">
                                            Syros EV
                                        </option>


                                        <option value="sorento">
                                            Sorento

                                        </option>
                                    </select>
                                </div>

                                {/* CAPTCHA */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "12px 0",
                                    }}
                                >
                                    {process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
                                        <ReCAPTCHA
                                            ref={this.recaptchaRef}
                                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                            onChange={this.handleCaptchaChange}
                                            onExpired={() =>
                                                this.setState({ captchaToken: null })
                                            }
                                        />
                                    ) : (
                                        <p style={{ color: "#d91c2b", fontSize: "13px" }}>
                                            Captcha not configured (missing REACT_APP_RECAPTCHA_SITE_KEY)
                                        </p>
                                    )}
                                </div>

                                {/* BUTTON */}
                                <button
                                    type="submit"
                                    disabled={this.state.loading}
                                    style={{
                                        width: "100%",
                                        height: isMobile
                                            ? "52px"
                                            : "54px",
                                        borderRadius: "14px",
                                        border: "none",
                                        background: "#d91c2b",
                                        color: "#fff",
                                        fontSize: isMobile
                                            ? "15px"
                                            : "16px",
                                        fontWeight: "700",
                                        cursor: "pointer",
                                        opacity: this.state.loading
                                            ? 0.7
                                            : 1,
                                    }}
                                >
                                    {this.state.loading
                                        ? "Submitting..."
                                        : "SUBMIT ENQUIRY"}
                                </button>

                            </form>
                        </>
                    )}

                </div>
            </div>
        );
    }
}

export default EnquiryFormModal;